import React from 'react'
import PropTypes from 'prop-types'
import { NavItem } from 'react-bootstrap'

class PageNavItemUnstyled extends React.Component {
  onSelect = (eventKey, event) => {
    const { href, history, activeHref } = this.props
    if (href.match(/^http/)) return
    if (href !== activeHref) history.push(href)
    event.preventDefault()
  }

  render = () => <NavItem {...this.props} onSelect={this.onSelect} />
}

PageNavItemUnstyled.propTypes = {
  href: PropTypes.string.isRequired,
  activeHref: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired,
}

export { PageNavItemUnstyled }



// WEBPACK FOOTER //
// ./src/Components/PageNav/PageNavItem/unstyled.js